var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3871_12363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03612 10.9189C2.82969 11.2809 2.0835 11.7809 2.0835 12.3331C2.0835 13.4377 5.06826 14.3331 8.75016 14.3331C12.4321 14.3331 15.4168 13.4377 15.4168 12.3331C15.4168 11.7809 14.6706 11.2809 13.4642 10.9189",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 11.6663C8.74984 11.6663 13.0832 8.83434 13.0832 5.56027C13.0832 3.22562 11.1431 1.33301 8.74984 1.33301C6.3566 1.33301 4.4165 3.22562 4.4165 5.56027C4.4165 8.83434 8.74984 11.6663 8.74984 11.6663Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75016 7.33333C9.67063 7.33333 10.4168 6.58713 10.4168 5.66667C10.4168 4.7462 9.67063 4 8.75016 4C7.8297 4 7.0835 4.7462 7.0835 5.66667C7.0835 6.58713 7.8297 7.33333 8.75016 7.33333Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3871_12363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.96e95dc94e31126b1fb6a5803a00d325.svg";
export { ForwardRef as ReactComponent };